'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var jungle={1:'#e8f7f2',2:'#c0eadb',3:'#86e0c2',4:'#24c991',5:'#1a9c6e',6:'#16825c',7:'#12694a',8:'#0d4f38',9:'#0a3c2b',10:'#07291d',inflection:6};exports.default=(0,_createColorPalette2.default)(jungle,'jungle');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/jungle.js
 **/